import React from 'react';
import { useEffect, useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { Typography, Button, Box, TextField, Select, OutlinedInput, Chip, MenuItem } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const StepTwoName = (props) => {
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [email, setEmail] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [title, setTitle] = useState('');
  // eslint-disable-next-line
  const [fullName, setFullName] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [about, setAbout] = useState('');
  const [bookingMethod, setBookingMethod] = useState('');
  const [skills, setSkills] = useState([]);

  const skillsList = [
    'Bootstrapping',
    'Building a team',
    'Content marketing',
    'Conversion rate optimization',
    'Copywriting',
    'Customer success',
    'Data science',
    'Design / UX',
    'Email marketing',
    'Facebook ads',
    'Go to market strategy',
    'Google ads',
    'Growth marketing',
    'Idea validation',
    'Link building',
    'Operations',
    'Marketing automation',
    'No-code',
    'Performance marketing',
    'PPC strategies',
    'Pricing strategy',
    'Product analytics',
    'Product management',
    'Product market fit',
    'Public relations',
    'Raising funding',
    'Sales',
    'SEO',
    'Social media',
    'User research',
    'Web Development',
  ];

  const handleSkillsChange = (event) => {
    const {
      target: { value },
    } = event;
    setSkills(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  let { id } = useParams();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      if (id) {
        let { data, error, status } = await supabase
          .from(PROFILE_TABLE)
          .select(`firstName, lastName, title, linkedin, about, skills, bookingMethod`)
          .eq('id', id)
          .single();

        let { data: userExists, error: errorExists } = await supabase
          .from(PROFILE_TABLE)
          .select(`email`)
          .eq('email', 'seantan1218@gmail.com')
          .single();

        console.log('USER EXISTS');
        console.log(userExists);
        console.log('ERROR EXISTS');
        console.log(errorExists);

        if (data) {
          setFirstName(data.firstName);
          setLastName(data.lastName);
          setTitle(data.title);
          setLinkedin(data.linkedin);
          setAbout(data.about);
          setSkills(data.skills);
          setBookingMethod(data.bookingMethod);
        }

        if (error && status !== 406) {
          throw error;
        }
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      setLoading(true);
      // e.preventDefault();
      if (id) {
        const updates = {
          id: id,
          firstName: formik.values.firstName,
          lastName: formik.values.lastName,
          fullName: formik.values.firstName + ' ' + formik.values.lastName,
          title: formik.values.title,
          linkedin: formik.values.linkedin,
          about: formik.values.about,
          bookingMethod: formik.values.bookingMethod,
          skills: skills,
          membershipLevel: 'member+mentor',
          updated_at: new Date(),
        };

        let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
          returning: 'minimal', // Don't return the value after inserting
        });

        if (error) {
          throw error;
        }
      } else {
        const { user, error } = await supabase.auth.signUp({
          email: formik.values.email,
          password: formik.values.password,
        });

        const { error2 } = await supabase.from(PROFILE_TABLE).insert({
          id: user.id,
          email: formik.values.email,
          firstName: formik.values.firstName,
          lastName: formik.values.lastName,
          fullName: formik.values.firstName + ' ' + formik.values.lastName,
          title: formik.values.title,
          linkedin: formik.values.linkedin,
          about: formik.values.about,
          bookingMethod: formik.values.bookingMethod,
          skills: skills,
          membershipLevel: 'mentor',
        });

        if (error || error2) {
          throw error;
        }
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = id
    ? yup.object({
        firstName: yup.string('Enter your first name').required('First name is required'),
        lastName: yup.string('Enter your last name').required('Last name is required'),
        title: yup.string('Enter your title').required('Title is required'),
        linkedin: yup.string('Enter your LinkedIn').required('LinkedIn is required'),
        about: yup.string('Share about yourself').required('Description is required'),
        bookingMethod: yup.string('Enter your Booking Method').required('Booking Method is required'),
      })
    : yup.object({
        firstName: yup.string('Enter your first name').required('First name is required'),
        lastName: yup.string('Enter your last name').required('Last name is required'),
        title: yup.string('Enter your title').required('Title is required'),
        linkedin: yup.string('Enter your LinkedIn').required('LinkedIn is required'),
        about: yup.string('Share about yourself').required('Description is required'),
        bookingMethod: yup.string('Enter your Booking Method').required('Booking Method is required'),
        email: yup.string('Enter your email').required('Email is required'),
        password: yup.string('Enter your password').required('Password is required'),
      });

  const formik = useFormik({
    initialValues: {
      firstName: firstName,
      lastName: lastName,
      title: title,
      linkedin: linkedin,
      about: about,
      bookingMethod: bookingMethod,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateProfile();
      props.handleNext();
    },
  });

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Fragment>
          <Typography variant='h4' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
            Let's get you set up. We'll need to know some information about you.
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id='firstName'
              name='firstName'
              label='First Name'
              type='firstName'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={formik.touched.firstName && Boolean(formik.errors.firstName)}
              helperText={formik.touched.firstName && formik.errors.firstName}
            />
            <TextField
              fullWidth
              id='lastName'
              name='lastName'
              label='Last Name'
              type='lastName'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
            />
            <TextField
              fullWidth
              id='title'
              name='title'
              label='Title (eg. Co-Founder of The 100 Club)'
              type='title'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.title}
              onChange={formik.handleChange}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
            />
            <TextField
              fullWidth
              id='linkedin'
              name='linkedin'
              label='Drop your personal LinkedIn link here'
              sx={{
                mb: '1rem',
              }}
              value={formik.values.linkedin}
              onChange={formik.handleChange}
              error={formik.touched.linkedin && Boolean(formik.errors.linkedin)}
              helperText={formik.touched.linkedin && formik.errors.linkedin}
            />
            <TextField
              inputProps={{ maxLength: 250 }}
              label='Describe yourself in 2 sentences.'
              multiline
              rows={3}
              fullWidth
              size='small'
              variant='outlined'
              id='about'
              type='url'
              value={formik.values.about}
              onChange={formik.handleChange}
              error={formik.touched.about && Boolean(formik.errors.about)}
              helperText={formik.touched.about && formik.errors.about}
              sx={{ mb: '1.5rem' }}
            />
            <TextField
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: true,
              }}
              label='How should a member book time with you?'
              placeholder='• Eg. Book a slot in my calendly here: calendly.com/xxx.
• Eg. Email me at XXX@gmail.com. Available weekday nights.
• Eg. Message me on telegram @XXX'
              multiline
              rows='4'
              fullWidth
              size='small'
              variant='outlined'
              id='bookingMethod'
              type='url'
              value={formik.values.bookingMethod}
              onChange={formik.handleChange}
              error={formik.touched.bookingMethod && Boolean(formik.errors.bookingMethod)}
              helperText={formik.touched.bookingMethod && formik.errors.bookingMethod}
              sx={{ mb: '1.5rem' }}
            />
            <Typography variant='body1' sx={{ my: '1rem', fontWeight: 'bold' }}>
              What are your top skills that people can find you for? (5 Max)
            </Typography>
            <Select
              fullWidth
              id='skills'
              name='skills'
              label='Select 2 skills'
              multiple
              value={skills || ''}
              onChange={handleSkillsChange}
              sx={{ mb: '1.5rem' }}
              input={<OutlinedInput id='select-multiple-chip' label='Chip' />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}>
              {skillsList.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
            {!id && (
              <div>
                <Typography variant='body1' sx={{ my: '1rem', fontWeight: 'bold' }}>
                  We'll be creating an account so you can edit your profile details.
                </Typography>
                <TextField
                  fullWidth
                  id='email'
                  name='email'
                  label='Email'
                  sx={{
                    mb: '1rem',
                  }}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  fullWidth
                  id='password'
                  name='password'
                  label='Password'
                  sx={{
                    mb: '1rem',
                  }}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                />
              </div>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button type='submit'>Register</Button>
            </Box>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
};

export default StepTwoName;
